export default {
    methods: {
        async handleCookiebotAccept () {
            this.$store.dispatch('Hubspot/CookiebotReady', true)
            if (Cookiebot.consent.statistics) {
                this.$store.dispatch('User/showFooterSubscribe', true)
                this.$store.dispatch('Hubspot/HubspotChatAvailable', true)
            } else {
                this.$store.dispatch('User/showFooterSubscribe', false)
                this.$store.dispatch('Hubspot/HubspotChatAvailable', false)
            }
            if (Cookiebot.changed) {
                this.removeGoogleAnalyticsCookies('.totem.local')
                this.removeGoogleAnalyticsCookies('.eduhouse.dev')
                this.removeGoogleAnalyticsCookies('.eduhouse.fi')
                this.clearHubSpotCookies()
            }
        },
        clearHubSpotCookies () {
            if (window.HubSpotConversations) {
                window.HubSpotConversations.widget.remove()
                window.HubSpotConversations.clear()
                window.location.reload()
            } else {
                window.hsConversationsOnReady = [
                    () => {
                        window.HubSpotConversations.widget.remove()
                        window.HubSpotConversations.clear()
                        window.location.reload()
                    },
                ]
                setTimeout(() => {
                    window.location.reload()
                }, 100)
            }
        },
        removeGoogleAnalyticsCookies (domain) {
            document.cookie.split(';').forEach(cookie => {
                const [name] = cookie.trim().split('=')

                if (name.includes('_ga_')) {
                    document.cookie = name + `=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`
                    document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'
                }
            })
        }
    },
    mounted () {
        this.$cookiebot.consentBanner({
            async: true,
            consentMode: 'disabled',
            locale: navigator.language || navigator.userLanguage
        })
        window.addEventListener('CookiebotOnAccept', this.handleCookiebotAccept)
        window.addEventListener('CookiebotOnDecline', this.handleCookiebotAccept)
    }
}
